import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { FaPlaneDeparture, FaPlaneArrival, FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import "../Flight/FlightToDeals.css";
import Why from "../Why/Why";
import axios from "axios";
import { toast } from "react-toastify";

import Deal from "../Deal/Deal";
import WhyChoose from "../WhyChoose/WhyChoose";

const destinationFlights = {
  orlando: [
    {
      id: 1,
      airline: "BA",
      airlineLogo: "/logos/BA.webp",
      departure: "Edinburgh Airport",
      destination: "Orlando Airport",
      departureDate: "04 Jan 26",
      returnDate: "10 Jun 26",
      price: "£284",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "VS",
      airlineLogo: "/logos/VS.webp",
      departure: "Manchester Airport",
      destination: "Orlando Airport",
      departureDate: "15 Jan 26",
      returnDate: "25 Jan 26",
      price: "£308",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Orlando Airport",
      departureDate: "26 Jan 26",
      returnDate: "28 Jan 26",
      price: "£313",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "AC",
      airlineLogo: "/logos/AC.webp",
      departure: "London All Airports",
      destination: "Orlando Airport",
      departureDate: "08 Mar 26",
      returnDate: "22 Mar 26",
      price: "£335",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "DL",
      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "Orlando Airport",
      departureDate: "18 Apr 26",
      returnDate: "02 May 26",
      price: "£360",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  "new-york": [
    {
      id: 1,
      airline: "IB",
      airlineLogo: "/logos/IB.webp",
      departure: "London All Airports",
      destination: "New York Airport",
      departureDate: "15 Mar 26",
      returnDate: "29 Mar 26",
      price: "£260",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "AC",
      airlineLogo: "/logos/AC.webp",
      departure: "London All Airports",
      destination: "New York Airport",
      departureDate: "05 Apr 26",
      returnDate: "19 Apr 26",
      price: "£265",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "AF",
      airlineLogo: "/logos/AF.webp",
      departure: "London All Airports",
      destination: "New York Airport",
      departureDate: "22 May 26",
      returnDate: "05 Jun 26",
      price: "£270",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "DL",
      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "New York Airport",
      departureDate: "10 Jun 26",
      returnDate: "24 Jun 26",
      price: "£270",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "LH",
      airlineLogo: "/logos/LH.webp",
      departure: "London All Airports",
      destination: "New York Airport",
      departureDate: "18 Jul 26",
      returnDate: "01 Aug 26",
      price: "£288",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  miami: [
    {
      id: 1,
      airline: "DL",
      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "Miami Airport",
      departureDate: "14 Feb 26",
      returnDate: "28 Feb 26",
      price: "£317",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Miami Airport",
      departureDate: "08 Apr 26",
      returnDate: "22 Apr 26",
      price: "£327",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "AC",
      airlineLogo: "/logos/AC.webp",
      departure: "London All Airports",
      destination: "Miami Airport",
      departureDate: "12 May 26",
      returnDate: "26 May 26",
      price: "£335",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Miami Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£339",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "LH",
      airlineLogo: "/logos/LH.webp",
      departure: "London All Airports",
      destination: "Miami Airport",
      departureDate: "30 Jul 26",
      returnDate: "13 Aug 26",
      price: "£398",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  "las-vegas": [
    {
      id: 1,
      airline: "DL",
      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "Las Vegas Airport",
      departureDate: "05 Mar 26",
      returnDate: "19 Mar 26",
      price: "£305",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Las Vegas Airport",
      departureDate: "18 Apr 26",
      returnDate: "02 May 26",
      price: "£310",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Las Vegas Airport",
      departureDate: "22 May 26",
      returnDate: "05 Jun 26",
      price: "£315",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "VS",
      airlineLogo: "/logos/VS.webp",
      departure: "London All Airports",
      destination: "Las Vegas Aiport",
      departureDate: "10 Jun 26",
      returnDate: "24 Jun 26",
      price: "£321",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "IB",
      airlineLogo: "/logos/IB.webp",
      departure: "London All Airports",
      destination: "Las Vegas Airport",
      departureDate: "15 Jul 26",
      returnDate: "29 Jul 26",
      price: "£330",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  atlanta: [
    {
      id: 1,
      airline: "DL",
      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "Atlanta Airport",
      departureDate: "12 Mar 26",
      returnDate: "26 Mar 26",
      price: "£317",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Atlanta Airport",
      departureDate: "08 Apr 26",
      returnDate: "22 Apr 26",
      price: "£327",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "AC",
      airlineLogo: "/logos/AC.webp",
      departure: "London All Airports",
      destination: "Atlanta Airport",
      departureDate: "15 May 26",
      returnDate: "29 May 26",
      price: "£335",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Atlanta Airport",
      departureDate: "20 Jun 26",
      returnDate: "04 Jul 26",
      price: "£339",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "LH",
      airlineLogo: "/logos/LH.webp",
      departure: "London All Airports",
      destination: "Atlanta Airport",
      departureDate: "25 Jul 26",
      returnDate: "08 Aug 26",
      price: "£398",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  dallas: [
    {
      id: 1,
      airline: "DL",
      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "Dallas Airport",
      departureDate: "10 Mar 26",
      returnDate: "24 Mar 26",
      price: "£317",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Dallas Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£327",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "AC",
      airlineLogo: "/logos/AC.webp",
      departure: "London All Airports",
      destination: "Dallas Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£335",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Dallas Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£355",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Dallas Airport",
      departureDate: "30 Jul 26",
      returnDate: "13 Aug 26",
      price: "£365",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  washington: [
    {
      id: 1,
      airline: "IB",
      airlineLogo: "/logos/IB.webp",
      departure: "London All Airports",
      destination: "Washington Airport",
      departureDate: "08 Mar 26",
      returnDate: "22 Mar 26",
      price: "£260",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "AC",
      airlineLogo: "/logos/AC.webp",
      departure: "London All Airports",
      destination: "Washington Airport",
      departureDate: "15 Apr 26",
      returnDate: "29 Apr 26",
      price: "£265",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "AF",
      airlineLogo: "/logos/AF.webp",
      departure: "London All Airports",
      destination: "Washington Airport",
      departureDate: "20 May 26",
      returnDate: "03 Jun 26",
      price: "£270",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "LH",
      airlineLogo: "/logos/LH.webp",
      departure: "London All Airports",
      destination: "Washington Airport",
      departureDate: "25 Jun 26",
      returnDate: "09 Jul 26",
      price: "£288",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "VS",
      airlineLogo: "/logos/VS.webp",
      departure: "London All Airports",
      destination: "Washington Airport",
      departureDate: "05 Aug 26",
      returnDate: "19 Aug 26",
      price: "£320",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  "san-francisco": [
    {
      id: 1,
      airline: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "San Francisco Airport",
      departureDate: "12 Mar 26",
      returnDate: "26 Mar 26",
      price: "£315",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "DL",
      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "San Francisco Airport",
      departureDate: "18 Apr 26",
      returnDate: "02 May 26",
      price: "£317",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "San Francisco Airport",
      departureDate: "22 May 26",
      returnDate: "05 Jun 26",
      price: "£320",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "AC",
      airlineLogo: "/logos/AC.webp",
      departure: "London All Airports",
      destination: "San Francisco Airport",
      departureDate: "10 Jun 26",
      returnDate: "24 Jun 26",
      price: "£330",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "VS",
      airlineLogo: "/logos/VS.webp",
      departure: "London All Airports",
      destination: "San Francisco Airport",
      departureDate: "15 Jul 26",
      returnDate: "29 Jul 26",
      price: "£440",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  tampa: [
    {
      id: 1,
      airline: "DL",
      airlineCode: "DL",
      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "Tampa Airport",
      departureDate: "10 Mar 26",
      returnDate: "24 Mar 26",
      price: "£317",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "UA",
      airlineCode: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Tampa Airport",
      departureDate: "08 Apr 26",
      returnDate: "22 Apr 26",
      price: "£327",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "AA",
      airlineCode: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Tampa Airport",
      departureDate: "15 May 26",
      returnDate: "29 May 26",
      price: "£335",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "AC",
      airlineCode: "AC",
      airlineLogo: "/logos/AC.webp",
      departure: "London All Airports",
      destination: "Tampa Airport",
      departureDate: "20 Jun 26",
      returnDate: "04 Jul 26",
      price: "£340",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "VS",
      airlineCode: "VS",
      airlineLogo: "/logos/VS.webp",
      departure: "London All Airports",
      destination: "Tampa Airport",
      departureDate: "25 Jul 26",
      returnDate: "08 Aug 26",
      price: "£345",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  toronto: [
    {
      id: 1,
      airline: "DL",
      airlineCode: "DL",
      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "Toronto Airport",
      departureDate: "05 Mar 26",
      returnDate: "19 Mar 26",
      price: "£346",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "UA",
      airlineCode: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Toronto Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£350",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "IB",
      airlineCode: "IB",
      airlineLogo: "/logos/IB.webp",
      departure: "London All Airports",
      destination: "Toronto Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£355",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "AA",
      airlineCode: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Toronto Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£355",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "AF",
      airlineCode: "AF",
      airlineLogo: "/logos/AF.webp",
      departure: "London All Airports",
      destination: "Toronto Airport",
      departureDate: "15 Jul 26",
      returnDate: "29 Jul 26",
      price: "£365",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  vancouver: [
    {
      id: 1,
      airline: "UA",
      airlineCode: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Vancouver Airport",
      departureDate: "08 Mar 26",
      returnDate: "22 Mar 26",
      price: "£415",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "DL",
      airlineCode: "DL",
      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "Vancouver Airport",
      departureDate: "15 Apr 26",
      returnDate: "29 Apr 26",
      price: "£421",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "AC",
      airlineCode: "AC",
      airlineLogo: "/logos/AC.webp",
      departure: "London All Airports",
      destination: "Vancouver Airport",
      departureDate: "20 May 26",
      returnDate: "03 Jun 26",
      price: "£430",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "KL",
      airlineCode: "KL",
      airlineLogo: "/logos/KL.webp",
      departure: "London All Airports",
      destination: "Vancouver Airport",
      departureDate: "25 Jun 26",
      returnDate: "09 Jul 26",
      price: "£430",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "AA",
      airlineCode: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Vancouver Airport",
      departureDate: "05 Aug 26",
      returnDate: "19 Aug 26",
      price: "£436",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  calgary: [
    {
      id: 1,
      airline: "UA",
      airlineCode: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Calgary Airport",
      departureDate: "10 Mar 26",
      returnDate: "24 Mar 26",
      price: "£429",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "DL",
      airlineCode: "DL",
      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "Calgary Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£435",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "AA",
      airlineCode: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Calgary Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£436",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "AC",
      airlineCode: "AC",
      airlineLogo: "/logos/AC.webp",
      departure: "London All Airports",
      destination: "Calgary Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£467",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  montreal: [
    {
      id: 1,
      airline: "UA",
      airlineCode: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Montreal Airport",
      departureDate: "12 Mar 26",
      returnDate: "26 Mar 26",
      price: "£375",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "AC",
      airlineCode: "AC",
      airlineLogo: "/logos/AC.webp",
      departure: "London All Airports",
      destination: "Montreal Airport",
      departureDate: "08 Apr 26",
      returnDate: "22 Apr 26",
      price: "£427",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "DL",
      airlineCode: "DL",
      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "Montreal Airport",
      departureDate: "15 May 26",
      returnDate: "29 May 26",
      price: "£435",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "KL",
      airlineCode: "KL",
      airlineLogo: "/logos/KL.webp",
      departure: "London All Airports",
      destination: "Montreal Airport",
      departureDate: "20 Jun 26",
      returnDate: "04 Jul 26",
      price: "£439",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "AA",
      airlineCode: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Montreal Airport",
      departureDate: "25 Jul 26",
      returnDate: "08 Aug 26",
      price: "£439",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  "montego-bay": [
    {
      id: 1,
      airline: "AA",

      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Montego Bay Airport",
      departureDate: "05 Mar 26",
      returnDate: "19 Mar 26",
      price: "£387",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "AC",

      airlineLogo: "/logos/AC.webp",
      departure: "London All Airports",
      destination: "Montego Bay Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£410",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "UA",

      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Montego Bay Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£412",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "VS",

      airlineLogo: "/logos/VS.webp",
      departure: "London All Airports",
      destination: "Montego Bay Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£417",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "DL",

      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "Montego Bay Airport",
      departureDate: "15 Jul 26",
      returnDate: "29 Jul 26",
      price: "£478",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  kingston: [
    {
      id: 1,
      airline: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Kingston Airport",
      departureDate: "08 Mar 26",
      returnDate: "22 Mar 26",
      price: "£390",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "BA",
      airlineLogo: "/logos/BA.webp",
      departure: "London All Airports",
      destination: "Kingston Airport",
      departureDate: "15 Apr 26",
      returnDate: "29 Apr 26",
      price: "£427",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "DL",
      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "Kingston Airport",
      departureDate: "20 May 26",
      returnDate: "03 Jun 26",
      price: "£440",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Kingston Airport",
      departureDate: "25 Jun 26",
      returnDate: "09 Jul 26",
      price: "£485",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  barbados: [
    {
      id: 1,
      airline: "VS",
      airlineLogo: "/logos/VS.webp",
      departure: "London All Airports",
      destination: "Barbados Airport",
      departureDate: "10 Mar 26",
      returnDate: "24 Mar 26",
      price: "£410",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "BA",
      airlineLogo: "/logos/BA.webp",
      departure: "London All Airports",
      destination: "Barbados Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£445",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Barbados Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£447",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Barbados Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£480",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  antigua: [
    {
      id: 1,
      airline: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Antigua Airport",
      departureDate: "12 Mar 26",
      returnDate: "26 Mar 26",
      price: "£437",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Antigua Airport",
      departureDate: "08 Apr 26",
      returnDate: "22 Apr 26",
      price: "£485",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "VS",
      airlineLogo: "/logos/VS.webp",
      departure: "London All Airports",
      destination: "Antigua Airport",
      departureDate: "15 May 26",
      returnDate: "29 May 26",
      price: "£499",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "AZ",
      airlineLogo: "/logos/AZ.webp",
      departure: "London All Airports",
      destination: "Antigua Airport",
      departureDate: "20 Jun 26",
      returnDate: "04 Jul 26",
      price: "£510",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "BA",
      airlineLogo: "/logos/BA.webp",
      departure: "London All Airports",
      destination: "Antigua Airport",
      departureDate: "25 Jul 26",
      returnDate: "08 Aug 26",
      price: "£530",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  grenada: [
    {
      id: 1,
      airline: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Grenada Airport",
      departureDate: "05 Mar 26",
      returnDate: "19 Mar 26",
      price: "£538",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Grenada Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£573",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "DL",
      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "Grenada Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£580",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "BA",
      airlineLogo: "/logos/BA.webp",
      departure: "London All Airports",
      destination: "Grenada Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£634",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  sydney: [
    {
      id: 1,
      airline: "CX",
      airlineLogo: "/logos/CX.webp",
      departure: "London All Airports",
      destination: "Sydney Airport",
      departureDate: "05 Mar 26",
      returnDate: "19 Mar 26",
      price: "£618",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "EY",
      airlineLogo: "/logos/EY.webp",
      departure: "London All Airports",
      destination: "Sydney Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£645",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "CZ",
      airlineLogo: "/logos/CZ.webp",
      departure: "London All Airports",
      destination: "Sydney Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£682",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "EK",
      airlineLogo: "/logos/EK.webp",
      departure: "London All Airports",
      destination: "Sydney Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£736",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "MH",
      airlineLogo: "/logos/MH.webp",
      departure: "London All Airports",
      destination: "Sydney Airport",
      departureDate: "15 Jul 26",
      returnDate: "29 Jul 26",
      price: "£833",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  brisbane: [
    {
      id: 1,
      airline: "KE",
      airlineLogo: "/logos/KE.webp",
      departure: "London All Airports",
      destination: "Brisbane Airport",
      departureDate: "08 Mar 26",
      returnDate: "22 Mar 26",
      price: "£603",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "CA",
      airlineLogo: "/logos/CA.webp",
      departure: "London All Airports",
      destination: "Brisbane Airport",
      departureDate: "15 Apr 26",
      returnDate: "29 Apr 26",
      price: "£625",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "CZ",
      airlineLogo: "/logos/CZ.webp",
      departure: "London All Airports",
      destination: "Brisbane Airport",
      departureDate: "20 May 26",
      returnDate: "03 Jun 26",
      price: "£642",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "EY",
      airlineLogo: "/logos/EY.webp",
      departure: "London All Airports",
      destination: "Brisbane Airport",
      departureDate: "25 Jun 26",
      returnDate: "09 Jul 26",
      price: "£643",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "MU",
      airlineLogo: "/logos/MU.webp",
      departure: "London All Airports",
      destination: "Brisbane Airport",
      departureDate: "05 Aug 26",
      returnDate: "19 Aug 26",
      price: "£643",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  melbourne: [
    {
      id: 1,
      airline: "MU",
      airlineLogo: "/logos/MU.webp",
      departure: "London All Airports",
      destination: "Melbourne Airport",
      departureDate: "10 Mar 26",
      returnDate: "24 Mar 26",
      price: "£541",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "CX",
      airlineLogo: "/logos/CX.webp",
      departure: "London All Airports",
      destination: "Melbourne Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£544",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "CZ",
      airlineLogo: "/logos/CZ.webp",
      departure: "London All Airports",
      destination: "Melbourne Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£562",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "EY",
      airlineLogo: "/logos/EY.webp",
      departure: "London All Airports",
      destination: "Melbourne Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£661",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "QR",
      airlineLogo: "/logos/QR.webp",
      departure: "London All Airports",
      destination: "Melbourne Airport",
      departureDate: "30 Jul 26",
      returnDate: "13 Aug 26",
      price: "£731",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  auckland: [
    {
      id: 1,
      airline: "CA",
      airlineLogo: "/logos/CA.webp",
      departure: "London All Airports",
      destination: "Auckland Airport",
      departureDate: "12 Mar 26",
      returnDate: "26 Mar 26",
      price: "£530",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "CX",
      airlineLogo: "/logos/CX.webp",
      departure: "London All Airports",
      destination: "Auckland Airport",
      departureDate: "08 Apr 26",
      returnDate: "22 Apr 26",
      price: "£611",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "CZ",
      airlineLogo: "/logos/CZ.webp",
      departure: "London All Airports",
      destination: "Auckland Airport",
      departureDate: "15 May 26",
      returnDate: "29 May 26",
      price: "£632",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "KE",
      airlineLogo: "/logos/KE.webp",
      departure: "London All Airports",
      destination: "Auckland Airport",
      departureDate: "20 Jun 26",
      returnDate: "04 Jul 26",
      price: "£703",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "MU",
      airlineLogo: "/logos/MU.webp",
      departure: "London All Airports",
      destination: "Auckland Airport",
      departureDate: "25 Jul 26",
      returnDate: "08 Aug 26",
      price: "£725",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  perth: [
    {
      id: 1,
      airline: "CZ",
      airlineLogo: "/logos/CZ.webp",
      departure: "London All Airports",
      destination: "Perth Airport",
      departureDate: "12 Mar 26",
      returnDate: "26 Mar 26",
      price: "£581",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "EY",
      airlineLogo: "/logos/EY.webp",
      departure: "London All Airports",
      destination: "Perth Airport",
      departureDate: "08 Apr 26",
      returnDate: "22 Apr 26",
      price: "£633",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "QR",
      airlineLogo: "/logos/QR.webp",
      departure: "London All Airports",
      destination: "Perth Airport",
      departureDate: "15 May 26",
      returnDate: "29 May 26",
      price: "£639",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "CX",
      airlineLogo: "/logos/CX.webp",
      departure: "London All Airports",
      destination: "Perth Airport",
      departureDate: "20 Jun 26",
      returnDate: "04 Jul 26",
      price: "£653",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "EK",
      airlineLogo: "/logos/EK.webp",
      departure: "London All Airports",
      destination: "Perth Airport",
      departureDate: "25 Jul 26",
      returnDate: "08 Aug 26",
      price: "£663",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  lagos: [
    {
      id: 1,
      airline: "ET",
      airlineLogo: "/logos/ET.webp",
      departure: "London All Airports",
      destination: "Lagos Airport",
      departureDate: "05 Mar 26",
      returnDate: "19 Mar 26",
      price: "£317",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "TK",
      airlineLogo: "/logos/TK.webp",
      departure: "London All Airports",
      destination: "Lagos Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£385",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "IB",
      airlineLogo: "/logos/IB.webp",
      departure: "London All Airports",
      destination: "Lagos Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£410",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "BA",
      airlineLogo: "/logos/BA.webp",
      departure: "London All Airports",
      destination: "Lagos Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£410",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "AF",
      airlineLogo: "/logos/AF.webp",
      departure: "London All Airports",
      destination: "Lagos Airport",
      departureDate: "15 Jul 26",
      returnDate: "29 Jul 26",
      price: "£420",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  accra: [
    {
      id: 1,
      airline: "TK",
      airlineLogo: "/logos/TK.webp",
      departure: "London All Airports",
      destination: "Accra Airport",
      departureDate: "08 Mar 26",
      returnDate: "22 Mar 26",
      price: "£310",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "IB",
      airlineLogo: "/logos/IB.webp",
      departure: "London All Airports",
      destination: "Accra Airport",
      departureDate: "15 Apr 26",
      returnDate: "29 Apr 26",
      price: "£315",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "TP",
      airlineLogo: "/logos/TP.webp",
      departure: "London All Airports",
      destination: "Accra Airport",
      departureDate: "20 May 26",
      returnDate: "03 Jun 26",
      price: "£315",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "KL",
      airlineLogo: "/logos/KL.webp",
      departure: "London All Airports",
      destination: "Accra Airport",
      departureDate: "25 Jun 26",
      returnDate: "09 Jul 26",
      price: "£320",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "AF",
      airlineLogo: "/logos/AF.webp",
      departure: "London All Airports",
      destination: "Accra Airport",
      departureDate: "05 Aug 26",
      returnDate: "19 Aug 26",
      price: "£325",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  harare: [
    {
      id: 1,
      airline: "ET",
      airlineLogo: "/logos/ET.webp",
      departure: "London All Airports",
      destination: "Harare Airport",
      departureDate: "10 Mar 26",
      returnDate: "24 Mar 26",
      price: "£317",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "KQ",
      airlineLogo: "/logos/KQ.webp",
      departure: "London All Airports",
      destination: "Harare Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£340",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "KL",
      airlineLogo: "/logos/KL.webp",
      departure: "London All Airports",
      destination: "Harare Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£480",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "EY",
      airlineLogo: "/logos/EY.webp",
      departure: "London All Airports",
      destination: "Harare Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£525",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "SA",
      airlineLogo: "/logos/SA.webp",
      departure: "London All Airports",
      destination: "Harare Airport",
      departureDate: "30 Jul 26",
      returnDate: "13 Aug 26",
      price: "£640",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  "cape-town": [
    {
      id: 1,
      airline: "TK",
      airlineLogo: "/logos/TK.webp",
      departure: "London All Airports",
      destination: "Cape Town Airport",
      departureDate: "12 Mar 26",
      returnDate: "26 Mar 26",
      price: "£445",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "KL",
      airlineLogo: "/logos/KL.webp",
      departure: "London All Airports",
      destination: "Cape Town Airport",
      departureDate: "08 Apr 26",
      returnDate: "22 Apr 26",
      price: "£445",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "SN",
      airlineLogo: "/logos/SN.webp",
      departure: "London All Airports",
      destination: "Cape Town Airport",
      departureDate: "15 May 26",
      returnDate: "29 May 26",
      price: "£445",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "LH",
      airlineLogo: "/logos/LH.webp",
      departure: "London All Airports",
      destination: "Cape Town Airport",
      departureDate: "20 Jun 26",
      returnDate: "04 Jul 26",
      price: "£450",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "EK",
      airlineLogo: "/logos/EK.webp",
      departure: "London All Airports",
      destination: "Cape Town Airport",
      departureDate: "25 Jul 26",
      returnDate: "08 Aug 26",
      price: "£455",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  entebbe: [
    {
      id: 1,
      airline: "ET",
      airlineLogo: "/logos/ET.webp",
      departure: "London All Airports",
      destination: "Entebbe Airport",
      departureDate: "05 Mar 26",
      returnDate: "19 Mar 26",
      price: "£337",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "KQ",
      airlineLogo: "/logos/KQ.webp",
      departure: "London All Airports",
      destination: "Entebbe Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£365",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "TK",
      airlineLogo: "/logos/TK.webp",
      departure: "London All Airports",
      destination: "Entebbe Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£375",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "EK",
      airlineLogo: "/logos/EK.webp",
      departure: "London All Airports",
      destination: "Entebbe Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£396",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "IB",
      airlineLogo: "/logos/IB.webp",
      departure: "London All Airports",
      destination: "Entebbe Airport",
      departureDate: "15 Jul 26",
      returnDate: "29 Jul 26",
      price: "£515",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  cali: [
    {
      id: 1,
      airline: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Cali Airport",
      departureDate: "05 Mar 26",
      returnDate: "19 Mar 26",
      price: "£395",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "KL",
      airlineLogo: "/logos/KL.webp",
      departure: "London All Airports",
      destination: "Cali Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£435",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "AV",
      airlineLogo: "/logos/AV.webp",
      departure: "London All Airports",
      destination: "Cali Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£435",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },

    {
      id: 4,
      airline: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Cali Airport",
      departureDate: "15 Jul 26",
      returnDate: "29 Jul 26",
      price: "£525",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  quito: [
    {
      id: 1,
      airline: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Quito Airport",
      departureDate: "08 Mar 26",
      returnDate: "22 Mar 26",
      price: "£435",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Quito Airport",
      departureDate: "15 Apr 26",
      returnDate: "29 Apr 26",
      price: "£465",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },

    {
      id: 3,
      airline: "DL",
      airlineLogo: "/logos/DL.webp",
      departure: "London All Airports",
      destination: "Quito Airport",
      departureDate: "25 Jun 26",
      returnDate: "09 Jul 26",
      price: "£490",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "IB",
      airlineLogo: "/logos/IB.webp",
      departure: "London All Airports",
      destination: "Quito Airport",
      departureDate: "05 Aug 26",
      returnDate: "19 Aug 26",
      price: "£570",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  lima: [
    {
      id: 1,
      airline: "AM",
      airlineLogo: "/logos/AM.webp",
      departure: "London All Airports",
      destination: "Lima Airport",
      departureDate: "10 Mar 26",
      returnDate: "24 Mar 26",
      price: "£390",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Lima Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£440",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "AA",
      airlineLogo: "/logos/AA.webp",
      departure: "London All Airports",
      destination: "Lima Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£475",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "IB",
      airlineLogo: "/logos/IB.webp",
      departure: "London All Airports",
      destination: "Lima Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£480",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "KL",
      airlineLogo: "/logos/KL.webp",
      departure: "London All Airports",
      destination: "Lima Airport",
      departureDate: "30 Jul 26",
      returnDate: "13 Aug 26",
      price: "£480",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  bogota: [
    {
      id: 1,
      airline: "IB",
      airlineLogo: "/logos/IB.webp",
      departure: "London All Airports",
      destination: "Bogota Airport",
      departureDate: "12 Mar 26",
      returnDate: "26 Mar 26",
      price: "£388",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "AV",
      airlineLogo: "/logos/AV.webp",
      departure: "London All Airports",
      destination: "Bogota Airport",
      departureDate: "08 Apr 26",
      returnDate: "22 Apr 26",
      price: "£390",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "AM",
      airlineLogo: "/logos/AM.webp",
      departure: "London All Airports",
      destination: "Bogota Airport",
      departureDate: "15 May 26",
      returnDate: "29 May 26",
      price: "£395",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "UA",
      airlineLogo: "/logos/UA.webp",
      departure: "London All Airports",
      destination: "Bogota Airport",
      departureDate: "20 Jun 26",
      returnDate: "04 Jul 26",
      price: "£440",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "AF",
      airlineLogo: "/logos/AF.webp",
      departure: "London All Airports",
      destination: "Bogota Airport",
      departureDate: "25 Jul 26",
      returnDate: "08 Aug 26",
      price: "£442",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  "sao-paulo": [
    {
      id: 1,
      airline: "UX",
      airlineLogo: "/logos/UX.webp",
      departure: "London All Airports",
      destination: "Sao Paulo Airport",
      departureDate: "05 Mar 26",
      returnDate: "19 Mar 26",
      price: "£340",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "AM",
      airlineLogo: "/logos/AM.webp",
      departure: "London All Airports",
      destination: "Sao Paulo Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£387",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "LH",
      airlineLogo: "/logos/LH.webp",
      departure: "London All Airports",
      destination: "Sao Paulo Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£461",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "IB",
      airlineLogo: "/logos/IB.webp",
      departure: "London All Airports",
      destination: "Sao Paulo Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£479",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "AF",
      airlineLogo: "/logos/AF.webp",
      departure: "London All Airports",
      destination: "Sao Paulo Airport",
      departureDate: "15 Jul 26",
      returnDate: "29 Jul 26",
      price: "£489",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  bangkok: [
    {
      id: 1,
      airline: "TK",
      airlineLogo: "/logos/TK.webp",
      departure: "London All Airports",
      destination: "Bangkok Airport",
      departureDate: "05 Mar 26",
      returnDate: "19 Mar 26",
      price: "£349",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "QR",
      airlineLogo: "/logos/QR.webp",
      departure: "London All Airports",
      destination: "Bangkok Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£359",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "IB",
      airlineLogo: "/logos/IB.webp",
      departure: "London All Airports",
      destination: "Bangkok Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£362",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "AF",
      airlineLogo: "/logos/AF.webp",
      departure: "London All Airports",
      destination: "Bangkok Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£372",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "EK",
      airlineLogo: "/logos/EK.webp",
      departure: "London All Airports",
      destination: "Bangkok Airport",
      departureDate: "15 Jul 26",
      returnDate: "29 Jul 26",
      price: "£378",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  bali: [
    {
      id: 1,
      airline: "CZ",
      airlineLogo: "/logos/CZ.webp",
      departure: "London All Airports",
      destination: "Bali Airport",
      departureDate: "08 Mar 26",
      returnDate: "22 Mar 26",
      price: "£479",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "CX",
      airlineLogo: "/logos/CX.webp",
      departure: "London All Airports",
      destination: "Bali Airport",
      departureDate: "15 Apr 26",
      returnDate: "29 Apr 26",
      price: "£479",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "BI",
      airlineLogo: "/logos/BI.webp",
      departure: "London All Airports",
      destination: "Bali Airport",
      departureDate: "20 May 26",
      returnDate: "03 Jun 26",
      price: "£485",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "CA",
      airlineLogo: "/logos/CA.webp",
      departure: "London All Airports",
      destination: "Bali Airport",
      departureDate: "25 Jun 26",
      returnDate: "09 Jul 26",
      price: "£489",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "PR",
      airlineLogo: "/logos/PR.webp",
      departure: "London All Airports",
      destination: "Bali Airport",
      departureDate: "05 Aug 26",
      returnDate: "19 Aug 26",
      price: "£490",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  phuket: [
    {
      id: 1,
      airline: "GF",
      airlineLogo: "/logos/GF.webp",
      departure: "London All Airports",
      destination: "Phuket Airport",
      departureDate: "10 Mar 26",
      returnDate: "24 Mar 26",
      price: "£365",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "CZ",
      airlineLogo: "/logos/CZ.webp",
      departure: "London All Airports",
      destination: "Phuket Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£410",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "EK",
      airlineLogo: "/logos/EK.webp",
      departure: "London All Airports",
      destination: "Phuket Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£423",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "AC",
      airlineLogo: "/logos/AC.webp",
      departure: "London All Airports",
      destination: "Phuket Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£450",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "QR",
      airlineLogo: "/logos/QR.webp",
      departure: "London All Airports",
      destination: "Phuket Airport",
      departureDate: "30 Jul 26",
      returnDate: "13 Aug 26",
      price: "£460",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  dubai: [
    {
      id: 1,
      airline: "TK",
      airlineLogo: "/logos/TK.webp",
      departure: "London All Airports",
      destination: "Dubai Airport",
      departureDate: "12 Mar 26",
      returnDate: "26 Mar 26",
      price: "£247",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "IB",
      airlineLogo: "/logos/IB.webp",
      departure: "London All Airports",
      destination: "Dubai Airport",
      departureDate: "08 Apr 26",
      returnDate: "22 Apr 26",
      price: "£295",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "AF",
      airlineLogo: "/logos/AF.webp",
      departure: "London All Airports",
      destination: "Dubai Airport",
      departureDate: "15 May 26",
      returnDate: "29 May 26",
      price: "£305",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "KL",
      airlineLogo: "/logos/KL.webp",
      departure: "London All Airports",
      destination: "Dubai Airport",
      departureDate: "20 Jun 26",
      returnDate: "04 Jul 26",
      price: "£309",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "EY",
      airlineLogo: "/logos/EY.webp",
      departure: "London All Airports",
      destination: "Dubai Airport",
      departureDate: "25 Jul 26",
      returnDate: "08 Aug 26",
      price: "£310",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  mumbai: [
    {
      id: 1,
      airline: "TK",
      airlineLogo: "/logos/TK.webp",
      departure: "London All Airports",
      destination: "Mumbai Airport",
      departureDate: "05 Mar 26",
      returnDate: "19 Mar 26",
      price: "£395",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "QR",
      airlineLogo: "/logos/QR.webp",
      departure: "London All Airports",
      destination: "Mumbai Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£410",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "GF",
      airlineLogo: "/logos/GF.webp",
      departure: "London All Airports",
      destination: "Mumbai Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£410",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "EY",
      airlineLogo: "/logos/EY.webp",
      departure: "London All Airports",
      destination: "Mumbai Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£460",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "BA",
      airlineLogo: "/logos/BA.webp",
      departure: "London All Airports",
      destination: "Mumbai Airport",
      departureDate: "15 Jul 26",
      returnDate: "29 Jul 26",
      price: "£489",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  delhi: [
    {
      id: 1,
      airline: "TK",
      airlineLogo: "/logos/TK.webp",
      departure: "London All Airports",
      destination: "Delhi Airport",
      departureDate: "08 Mar 26",
      returnDate: "22 Mar 26",
      price: "£395",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "QR",
      airlineLogo: "/logos/QR.webp",
      departure: "London All Airports",
      destination: "Delhi Airport",
      departureDate: "15 Apr 26",
      returnDate: "29 Apr 26",
      price: "£410",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "GF",
      airlineLogo: "/logos/GF.webp",
      departure: "London All Airports",
      destination: "Delhi Airport",
      departureDate: "20 May 26",
      returnDate: "03 Jun 26",
      price: "£410",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "EY",
      airlineLogo: "/logos/EY.webp",
      departure: "London All Airports",
      destination: "Delhi Airport",
      departureDate: "25 Jun 26",
      returnDate: "09 Jul 26",
      price: "£460",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "BA",
      airlineLogo: "/logos/BA.webp",
      departure: "London All Airports",
      destination: "Delhi Airport",
      departureDate: "05 Aug 26",
      returnDate: "19 Aug 26",
      price: "£489",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
  chennai: [
    {
      id: 1,
      airline: "TK",
      airlineLogo: "/logos/TK.webp",
      departure: "London All Airports",
      destination: "Chennai Airport",
      departureDate: "10 Mar 26",
      returnDate: "24 Mar 26",
      price: "£395",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 2,
      airline: "QR",
      airlineLogo: "/logos/QR.webp",
      departure: "London All Airports",
      destination: "Chennai Airport",
      departureDate: "12 Apr 26",
      returnDate: "26 Apr 26",
      price: "£410",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 3,
      airline: "GF",
      airlineLogo: "/logos/GF.webp",
      departure: "London All Airports",
      destination: "Chennai Airport",
      departureDate: "18 May 26",
      returnDate: "01 Jun 26",
      price: "£410",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 4,
      airline: "EY",
      airlineLogo: "/logos/EY.webp",
      departure: "London All Airports",
      destination: "Chennai Airport",
      departureDate: "22 Jun 26",
      returnDate: "06 Jul 26",
      price: "£460",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
    {
      id: 5,
      airline: "BA",
      airlineLogo: "/logos/BA.webp",
      departure: "London All Airports",
      destination: "Chennai Airport",
      departureDate: "30 Jul 26",
      returnDate: "13 Aug 26",
      price: "£489",
      contactNumber: "02033557350  ",
      contactEmail: "info@click4flight.co.uk",
    },
  ],
};

const destinationInfo = {
  orlando: {
    name: "Orlando",
    image: "/orlando.webp",
    about: [
      "Orlando is the theme park capital of the world. Families of all ages can enjoy magical experiences at Walt Disney World, Universal Studios, and SeaWorld, or swim with dolphins at Discovery Cove.",
      "If theme parks are not your thing, Orlando also offers premium outlet shopping, championship golf courses, and some of Florida's most beautiful beaches just a short drive away.",
      "With year-round sunshine and world-class attractions, it's no surprise that millions of visitors from around the globe choose Orlando every year.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  "new-york": {
    name: "New York",
    image: "/new-york.webp",
    about: [
      "New York City, the city that never sleeps, offers iconic landmarks like Times Square, Central Park, and the Statue of Liberty.",
      "Experience world-class Broadway shows, diverse culinary scenes, and unparalleled shopping from Fifth Avenue to SoHo.",
      "With its vibrant energy and endless attractions, New York remains one of the world's most visited destinations.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  miami: {
    name: "Miami",
    image: "/miami.avif",
    about: [
      "Miami is famous for its beautiful beaches, vibrant nightlife, and Art Deco architecture in South Beach.",
      "Enjoy Cuban cuisine in Little Havana, explore the Wynwood Walls street art, or relax in the tropical paradise of the Florida Keys nearby.",
      "With its unique blend of cultures and year-round sunshine, Miami offers a perfect mix of relaxation and excitement.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  "las-vegas": {
    name: "Las Vegas",
    image: "/las-vegas.webp",
    about: [
      "Las Vegas, the entertainment capital of the world, offers dazzling shows, world-class casinos, and luxury resorts.",
      "Beyond the Strip, explore the natural wonders of the Grand Canyon, Red Rock Canyon, and Hoover Dam.",
      "Whether you're looking for nightlife, fine dining, or adventure, Las Vegas delivers an unforgettable experience.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  atlanta: {
    name: "Atlanta",
    image: "/atlanta.webp",
    about: [
      "Atlanta blends Southern charm with modern innovation, home to CNN, Coca-Cola World, and the Martin Luther King Jr. National Historical Park.",
      "Enjoy thriving food scenes, beautiful parks, and rich civil rights history throughout the city.",
      "As a major transportation hub and cultural center, Atlanta offers diverse experiences for every traveler.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  dallas: {
    name: "Dallas",
    image: "/dallas.avif",
    about: [
      "Dallas offers a mix of modern sophistication and Western heritage, with landmarks like Dealey Plaza and the Sixth Floor Museum.",
      "Enjoy world-class shopping, thriving arts districts, and authentic Texas barbecue throughout the city.",
      "With its booming economy and cultural attractions, Dallas provides a unique Texas experience.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  washington: {
    name: "Washington",
    image: "/washington.webp",
    about: [
      "Washington D.C., the nation's capital, is home to iconic monuments, Smithsonian museums, and the White House.",
      "Explore free world-class museums, historic neighborhoods like Georgetown, and beautiful cherry blossoms in spring.",
      "As the political and historical heart of America, Washington D.C. offers unparalleled educational and cultural experiences.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  "san-francisco": {
    name: "San Francisco",
    image: "/san-f.webp",
    about: [
      "San Francisco is famous for the Golden Gate Bridge, historic cable cars, and vibrant neighborhoods like Chinatown and Fisherman's Wharf.",
      "Experience tech innovation in Silicon Valley, wine tasting in Napa Valley, and natural beauty in nearby national parks.",
      "With its stunning views and diverse culture, San Francisco remains one of America's most beloved cities.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  tampa: {
    name: "Tampa",
    image: "/tampa.webp",
    about: [
      "Tampa offers beautiful Gulf Coast beaches, family-friendly attractions like Busch Gardens, and historic Ybor City.",
      "Enjoy water activities, professional sports, and fresh seafood in this vibrant Florida city.",
      "With its warm climate and relaxed atmosphere, Tampa provides the perfect Florida getaway for families and couples alike.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  toronto: {
    name: "Toronto",
    image: "/toronto.webp",
    about: [
      "Toronto, Canada's largest city, offers a vibrant multicultural experience with iconic landmarks like the CN Tower and Royal Ontario Museum.",
      "Explore diverse neighborhoods like Kensington Market and Distillery District, or enjoy waterfront activities on Lake Ontario.",
      "With world-class dining, entertainment, and shopping, Toronto provides a perfect blend of urban excitement and natural beauty.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  vancouver: {
    name: "Vancouver",
    image: "/van-couver.webp",
    about: [
      "Vancouver is renowned for its stunning natural setting between mountains and ocean, offering outdoor adventures year-round.",
      "Explore Stanley Park, Granville Island Public Market, and the historic Gastown district with its iconic steam clock.",
      "With mild climate, diverse culture, and world-class dining, Vancouver consistently ranks as one of the world's most livable cities.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  calgary: {
    name: "Calgary",
    image: "/calgary.webp",
    about: [
      "Calgary is the gateway to the Canadian Rockies and famous for the annual Calgary Stampede, 'The Greatest Outdoor Show on Earth'.",
      "Enjoy western hospitality, visit the Calgary Tower for panoramic views, or explore nearby Banff National Park.",
      "With its entrepreneurial spirit and proximity to natural wonders, Calgary offers a unique blend of urban sophistication and outdoor adventure.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  montreal: {
    name: "Montreal",
    image: "/montreal-skyline.webp",
    about: [
      "Montreal offers European charm in North America, with its historic Old Port, Notre-Dame Basilica, and Mount Royal Park.",
      "Experience world-class festivals, diverse culinary scenes, and the unique blend of French and English cultures.",
      "As Canada's cultural capital, Montreal provides a vibrant arts scene, historic architecture, and unforgettable four-season experiences.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  "montego-bay": {
    name: "Montego Bay",
    image: "/montegobay.webp",
    about: [
      "Montego Bay, Jamaica's tourist capital, is famous for its beautiful beaches, all-inclusive resorts, and vibrant nightlife.",
      "Enjoy Doctor's Cave Beach, explore the historic Rose Hall Great House, or experience authentic Jamaican culture and cuisine.",
      "With its warm hospitality, reggae music, and crystal-clear waters, Montego Bay offers the perfect Caribbean escape.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  kingston: {
    name: "Kingston",
    image: "/kingston.webp",
    about: [
      "Kingston, Jamaica's capital, is the cultural heart of the island with rich history, music heritage, and vibrant street life.",
      "Visit the Bob Marley Museum, explore the historic Devon House, or experience authentic Jamaican patties and jerk cuisine.",
      "As the birthplace of reggae and dancehall music, Kingston offers a unique blend of urban energy and Caribbean charm.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  barbados: {
    name: "Barbados",
    image: "/barba.webp",
    about: [
      "Barbados offers pristine white-sand beaches, turquoise waters, and a rich British colonial heritage blended with Caribbean culture.",
      "Explore historic Bridgetown, swim with turtles, or enjoy world-class surfing on the Atlantic coast.",
      "Known for its friendly people, cricket culture, and rum production, Barbados provides a sophisticated Caribbean experience.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  antigua: {
    name: "Antigua",
    image: "/Antigua.webp",
    about: [
      "Antigua is famous for having 365 beaches - one for every day of the year - with stunning white sands and clear blue waters.",
      "Explore Nelson's Dockyard National Park, a UNESCO World Heritage site, or experience the vibrant sailing culture.",
      "With perfect weather, beautiful resorts, and friendly locals, Antigua is a true Caribbean paradise for sun-seekers.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  grenada: {
    name: "Grenada",
    image: "/grenada.webp",
    about: [
      "Grenada, the 'Spice Isle', is renowned for its nutmeg production, pristine beaches, and lush rainforest landscapes.",
      "Explore the underwater sculpture park, visit cocoa and spice plantations, or hike to stunning waterfalls.",
      "With its fragrant spice markets, friendly atmosphere, and natural beauty, Grenada offers an authentic Caribbean experience.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  sydney: {
    name: "Sydney",
    image: "/sydney.webp",
    about: [
      "Sydney, Australia's iconic harbour city, is famous for the Sydney Opera House, Harbour Bridge, and stunning Bondi Beach.",
      "Explore the historic Rocks district, enjoy world-class dining in Darling Harbour, or take a coastal walk from Bondi to Coogee.",
      "With its vibrant culture, beautiful beaches, and cosmopolitan atmosphere, Sydney offers an unforgettable Australian experience.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  auckland: {
    name: "Auckland",
    image: "/auck.webp",
    about: [
      "Auckland, New Zealand's largest city, is nestled between two harbours and known as the 'City of Sails' for its maritime culture.",
      "Discover the panoramic views from Sky Tower, explore volcanic Rangitoto Island, or wander through the vibrant Viaduct Harbour.",
      "Surrounded by beautiful beaches, wine regions, and native rainforests, Auckland offers a perfect blend of urban sophistication and natural adventure.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  brisbane: {
    name: "Brisbane",
    image: "/brisbane.webp",
    about: [
      "Brisbane offers a subtropical climate, beautiful riverfront parks, and easy access to the Gold Coast and Sunshine Coast.",
      "Explore South Bank's cultural precinct, visit Lone Pine Koala Sanctuary, or enjoy the vibrant dining scene in Fortitude Valley.",
      "As Queensland's capital, Brisbane combines urban sophistication with outdoor lifestyle, perfect for exploring Australia's east coast.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  melbourne: {
    name: "Melbourne",
    image: "/mel.webp",
    about: [
      "Melbourne is Australia's cultural capital, renowned for its laneway cafes, street art, and world-class sporting events.",
      "Experience the vibrant food scene, visit the National Gallery of Victoria, or explore the Royal Botanic Gardens.",
      "With its European-style architecture, tram network, and creative energy, Melbourne offers a sophisticated urban experience.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  perth: {
    name: "Perth",
    image: "/perth.webp",
    about: [
      "Perth, one of the world's most isolated major cities, offers stunning beaches, beautiful parks, and a relaxed outdoor lifestyle.",
      "Explore Kings Park with panoramic city views, visit Rottnest Island to see quokkas, or enjoy the Swan Valley wine region.",
      "With more sunshine than any other Australian capital and beautiful Indian Ocean beaches, Perth provides a true west coast experience.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  lagos: {
    name: "Lagos",
    image: "/Lagos.webp",
    about: [
      "Lagos, Nigeria's bustling commercial capital, is Africa's most populous city with vibrant energy, music scene, and entrepreneurial spirit.",
      "Experience the lively markets of Balogun and Computer Village, visit the Nike Art Gallery, or relax on Tarkwa Bay beach.",
      "As West Africa's economic hub, Lagos offers a unique blend of traditional culture, modern business, and vibrant nightlife.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  accra: {
    name: "Accra",
    image: "/accra.webp",
    about: [
      "Accra, Ghana's coastal capital, offers rich history, vibrant culture, and beautiful beaches along the Gulf of Guinea.",
      "Visit the Kwame Nkrumah Mausoleum, explore Jamestown's historic district, or experience the bustling Makola Market.",
      "Known for its warm hospitality and growing economy, Accra provides a gateway to Ghana's rich cultural heritage and natural beauty.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  harare: {
    name: "Harare",
    image: "/harare.webp",
    about: [
      "Harare, Zimbabwe's capital, is known for its beautiful jacaranda-lined streets, vibrant arts scene, and nearby natural wonders.",
      "Explore the National Gallery of Zimbabwe, visit the Mbare Musika market, or take a day trip to nearby Lake Chivero.",
      "As the gateway to Victoria Falls and wildlife reserves, Harare offers a blend of urban sophistication and access to African wilderness.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  "cape-town": {
    name: "Cape Town",
    image: "/cape.avif",
    about: [
      "Cape Town, one of the world's most beautiful cities, is nestled between Table Mountain and the Atlantic Ocean.",
      "Visit the iconic Table Mountain, explore the historic Robben Island, or enjoy the vibrant V&A Waterfront and nearby wine regions.",
      "With stunning natural beauty, rich history, and diverse culture, Cape Town offers an unforgettable South African experience.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  entebbe: {
    name: "Entebbe",
    image: "/Entebbe-town.webp",
    about: [
      "Entebbe, located on the shores of Lake Victoria, is Uganda's gateway city known for its botanical gardens and wildlife conservation.",
      "Visit the Uganda Wildlife Education Centre, explore the beautiful Entebbe Botanical Gardens, or take boat trips on Lake Victoria.",
      "As the starting point for gorilla trekking adventures and wildlife safaris, Entebbe offers access to Uganda's incredible natural wonders.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  cali: {
    name: "Cali",
    image: "/cali.avif",
    about: [
      "Cali, known as the 'Salsa Capital of the World', is Colombia's third-largest city with vibrant music, dance, and nightlife.",
      "Experience authentic salsa dancing, visit the historic San Antonio neighborhood, or explore the beautiful Cali River gorge.",
      "With its warm climate, friendly people, and rich Afro-Colombian culture, Cali offers a unique South American experience.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  quito: {
    name: "Quito",
    image: "/quito.webp",
    about: [
      "Quito, Ecuador's capital, is one of the world's highest capital cities and a UNESCO World Heritage site with well-preserved colonial architecture.",
      "Explore the historic Old Town, visit the equator monument at Mitad del Mundo, or take a cable car up Pichincha Volcano.",
      "As the gateway to the Galapagos Islands and Amazon rainforest, Quito offers access to Ecuador's incredible natural wonders.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  lima: {
    name: "Lima",
    image: "/lima.webp",
    about: [
      "Lima, Peru's coastal capital, is renowned for its colonial architecture, world-class cuisine, and rich pre-Columbian history.",
      "Explore the historic Plaza de Armas, visit the Larco Museum, or experience the vibrant food scene in the Miraflores district.",
      "As the gateway to Machu Picchu and the Sacred Valley, Lima combines historical significance with modern sophistication.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  bogota: {
    name: "Bogota",
    image: "/bogota.webp",
    about: [
      "Bogota, Colombia's capital high in the Andes, offers a blend of colonial history, modern culture, and stunning mountain views.",
      "Visit the Gold Museum, explore the historic La Candelaria district, or take a cable car up Monserrate for panoramic city views.",
      "With its vibrant arts scene, growing gastronomy, and friendly atmosphere, Bogota is South America's rising cultural capital.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  "sao-paulo": {
    name: "Sao Paulo",
    image: "/sau.webp",
    about: [
      "Sao Paulo, Brazil's sprawling metropolis, is South America's largest city with world-class dining, arts, and vibrant nightlife.",
      "Explore the Museum of Art of Sao Paulo (MASP), visit the historic Municipal Market, or experience the diverse neighborhoods.",
      "As Brazil's economic and cultural hub, Sao Paulo offers endless entertainment, culinary diversity, and urban energy.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  bangkok: {
    name: "Bangkok",
    image: "/bankok.webp",
    about: [
      "Bangkok, Thailand's vibrant capital, offers a perfect blend of ancient temples, modern skyscrapers, and bustling street markets.",
      "Visit the Grand Palace and Wat Arun, experience floating markets, or enjoy world-class shopping and street food.",
      "Known as the 'City of Angels', Bangkok provides an exotic mix of traditional culture and contemporary urban excitement.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  bali: {
    name: "Bali",
    image: "/bali.webp",
    about: [
      "Bali, Indonesia's island paradise, is famous for its volcanic mountains, iconic rice paddies, beaches, and coral reefs.",
      "Experience Hindu temple ceremonies in Ubud, surf in Kuta, or relax in luxury resorts along the beautiful coastlines.",
      "With its spiritual atmosphere, artistic communities, and stunning natural beauty, Bali offers the ultimate tropical escape.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  phuket: {
    name: "Phuket",
    image: "/phuket.avif",
    about: [
      "Phuket, Thailand's largest island, offers stunning beaches, vibrant nightlife, and access to the beautiful Phi Phi Islands.",
      "Relax on Patong Beach, visit the Big Buddha, explore Old Phuket Town, or take boat trips to nearby islands.",
      "With its combination of natural beauty, exciting activities, and Thai hospitality, Phuket is a premier beach destination.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  dubai: {
    name: "Dubai",
    image: "/dubai.webp",
    about: [
      "Dubai, the ultramodern city in the United Arab Emirates, is known for luxury shopping, futuristic architecture, and lively nightlife.",
      "Visit the Burj Khalifa, explore the Dubai Mall, experience desert safaris, or relax at Jumeirah Beach.",
      "As a global business hub and tourist destination, Dubai offers unparalleled luxury experiences and year-round sunshine.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  mumbai: {
    name: "Mumbai",
    image: "/mumbai.webp",
    about: [
      "Mumbai, India's financial capital, is a bustling metropolis known for Bollywood, colonial architecture, and vibrant street life.",
      "Visit the Gateway of India, explore Elephanta Caves, experience the Dhobi Ghat laundry, or enjoy street food at Chowpatty Beach.",
      "As the city of dreams, Mumbai offers a dynamic mix of tradition and modernity, poverty and extreme wealth.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  delhi: {
    name: "Delhi",
    image: "/delhi.webp",
    about: [
      "Delhi, India's capital territory, combines historic monuments, bustling markets, and modern infrastructure in one vibrant city.",
      "Explore the Red Fort, visit India Gate, experience Chandni Chowk market, or see the Qutub Minar complex.",
      "With its rich Mughal heritage, political significance, and diverse culture, Delhi offers a complete Indian experience.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
  chennai: {
    name: "Chennai",
    image: "/chennai.webp",
    about: [
      "Chennai, on India's southeastern coast, is known for its temples, classical dance, and being the gateway to South India.",
      "Visit Kapaleeshwarar Temple, explore Fort St. George, relax on Marina Beach, or experience traditional Bharatanatyam dance.",
      "As a major cultural, economic, and educational center, Chennai offers authentic South Indian culture and cuisine.",
    ],
    contact: {
      phone: "02033557350  ",
      timing: "Round-the-Clock Support",
    },
  },
};

const handleCallClick = () => {
  window.location.href = "tel:02033557350  ";
};
const handleEmailClick = () => {
  window.location.href = "mailto:info@click4flight.co.uk";
};

export default function FlightToDeal() {
  const { destinationId } = useParams();
  const navigate = useNavigate();
  const [flights, setFlights] = useState([]);
  const [flightData, setFlightData] = useState([]);
  const [destination, setDestination] = useState(null);
  const [airportCode, setAirportCode] = useState("");

  useEffect(() => {
    const fetchFlights = async () => {
      try {
        const data = await axios.get(`
          ${process.env.REACT_APP_BASE_URL}/flight/destination/${destinationId}
        `);

        setAirportCode(data?.data?.airportCode);

        setFlightData(data?.data?.flights);
      } catch (err) {
        toast.error("No flights found");
      }
    };

    fetchFlights();
  }, [destinationId]);

  useEffect(() => {
    setFlights(destinationFlights[destinationId] || []);
    setDestination(destinationInfo[destinationId] || null);
  }, [destinationId]);

  if (!destination) return null;

  return (
    <div className="flight-page">
      {/* HERO */}
      <div className="flight-hero">
        <img src={destination.image} alt={destination.name} />
        <div className="flight-hero-overlay">
          <h1>Return Flights to {destination.name}</h1>
          <button onClick={() => navigate(-1)}>← Go Back</button>
        </div>
      </div>
      <Deal />
      {/* FLIGHT DEALS */}
      <section className="flight-deals-section">
        <div className="flight-deals-header">
          <h2>Return Flight Deals to {destination.name}</h2>
          <p>Compare the best fares from major UK airports</p>
        </div>

        <div className="flight-container">
          {flightData.map((flight) => (
            <div key={flight._id} className="flight-card-horizontal">
              <div className="fc-airline">
                <img
                  src={`/logos/${flight.airline.toUpperCase()}.webp`}
                  alt={flight.airline}
                />
              </div>

              <div className="fc-details">
                <p>
                  <strong>Return Flights to</strong>
                </p>
                <p>
                  <strong> {destination.name} Airport</strong>
                </p>
              </div>

              {/*-- <div className="fc-dates">
                <div className="fc-date">
                  <FaPlaneDeparture /> {flight.departureDate}
                </div>
                <div className="fc-date">
                  <FaPlaneArrival /> {flight.returnDate}
                </div>
              </div>
              --*/}

              <div className="fc-price">
                <span>from</span>
                <strong>£{flight.price}</strong>
                <small>pp</small>
              </div>

              <div className="fc-contact">
                <h4>Call Now To Save Upto 30%</h4>
                <span onClick={handleCallClick}>
                  <FaPhoneAlt /> 02033557350
                </span>
                <span onClick={handleEmailClick}>
                  <MdEmail /> info@click4flight.co.uk
                </span>
              </div>
              <div className="fc-details">
                <button
                  className="trip-btn-ib"
                  onClick={() => {
                    // Set flag
                    localStorage.setItem("autoOpenBook", "true");

                    // Helper function to format date as YYYY-MM-DD
                    const formatDate = (date) =>
                      date.toISOString().split("T")[0];

                    const today = new Date();

                    // Departure = today + 14 days
                    const departureDate = new Date(today);
                    departureDate.setDate(today.getDate() + 14);

                    // Return = today + 30 days
                    const returnDate = new Date(today);
                    returnDate.setDate(today.getDate() + 30);

                    navigate(
                      `/flight-result?origin=LON&destination=${
                        flight?.arrival?.airport
                      }&destinationName=${encodeURIComponent(
                        `${destination.name} Airport`,
                      )}&openBook=true`,
                    );
                  }}
                >
                  Check Flights
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* ABOUT SECTION */}
      <section className="flight-about">
        <div className="flight-about-container">
          <div className="flight-about-content">
            <h2>Return Flights To {destination.name}</h2>

            {destination.about.map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </div>

          <div className="flight-about-cta">
            <h3>
              Connect With a Travel <br /> Consultant
            </h3>

            <div className="cta-phone" onClick={handleCallClick}>
              <FaPhoneAlt />
              <span>{destination.contact.phone}</span>
            </div>

            <p className="cta-time">({destination.contact.timing})</p>
          </div>
        </div>
      </section>
      <WhyChoose />
    </div>
  );
}
